// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"665":"674ddbf4","677":"5e33d6c7","766":"36583445","983":"7958bd01"}[chunkId] + ".chunk.js";
};